import CryptoJS from 'crypto-js';

export const decryptData = (encryptedText) => {
    const encryptionKey = '123THAIGL0033221';
    const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000'); // 16 bytes of zeros

    // ถอดรหัสโดยใช้ AES CBC โหมด
    const decrypted = CryptoJS.AES.decrypt(encryptedText, CryptoJS.enc.Utf8.parse(encryptionKey), {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    // แปลงข้อมูลที่ถอดรหัสแล้วเป็น string และส่งคืนข้อมูล
    return decrypted.toString(CryptoJS.enc.Utf8);
};

